export const CANCEL_SUBSCRIPTION = 'cancel_subscription' as const;
export const CANCEL_SUBSCRIPTION_CONFIRMATION = 'cancel_subscription_confirmation' as const;
export const UPDATE_PAYMENT_CONFIRMATION = 'update_payment_confirmation' as const;
export const SEE_MY_OFFERS_CLICKED = 'see_my_offers_clicked' as const;
export const OFFER_REDEEM_SUBSCRIPTION = 'offer_redeem_subscription' as const;
export const PARTNER_SUBSCRIPTION = 'partner_subscription' as const;
export const SUBSCRIPTION = 'subscription' as const;
export const SUBSCRIPTION_SWITCH_PLAN = 'subscription_switch_plan' as const;

export const STUDENT_ACTIVE = 'student_active' as const;
export const STUDENT_REVERIFY = 'student_reverify' as const;
export const REVERIFY_NOW = 'reverify_now' as const;
export const REVERIFY_SUCCESS = 'reverify_success' as const;

export const UPGRADE_LANDING_PAGE = 'upgrade_landing_page' as const;
